import React from "react";
import { Typography } from "@material-ui/core";
import { Li, ListItem, StyledTable } from "./Components";

import ste_wor_haz_lev from "../img/sswpIcons/SteelWorks/ste_wor_haz_lev.png";
import ste_wor_fal_and_arr from "../img/sswpIcons/SteelWorks/ste_wor_fal_and_arr.png";
import ste_wor_net_bea_bag from "../img/sswpIcons/SteelWorks/ste_wor_net_bea_bag.png";
import ste_wor_saf_acc from "../img/sswpIcons/SteelWorks/ste_wor_acc.png";
import ste_wor_saf_lin from "../img/sswpIcons/SteelWorks/ste_wor_saf_lin.png";
import ste_wor_sit_spe_met from "../img/sswpIcons/SteelWorks/ste_wor_sit_spe_met.png";

const json = {
    icon: ste_wor_haz_lev,
    name: "Steel Works",
    text: "",
    icons: {
        ste_wor_acc: {
            name: "Access/ Egress",
            icon: ste_wor_saf_acc,
            text: (
                <ul>
                    <ListItem text="There must be safe walking routes for workers to/ from/ and within the site" />
                    <ListItem text="There must be safe access using ladders" />
                    <ListItem text="Access to be kept clear from obstruction, materials, and equipment" />
                    <ListItem text="Access should be kept clean and tidy" />
                </ul>
            )
        },
        ste_wor_fal_and_arr: {
            name: "Fall Arrest & Rescue",
            icon: ste_wor_fal_and_arr,
            text: (
                <ul>
                    <ListItem text="Cannot be used to replace safe working platforms or safety nets. (Fall restraint)." />
                    <ListItem text="Fall Arrest and Rescue equipment needs to be inspected regularly and visually before each use." />
                    <ListItem text="Operatives must be trained" />
                    <Li>
                        <Typography variant="title">
                            Should be used in connection with a rescue plan.
                            This plan must ensure the operative can be retrieved
                            as soon as possible after the fall and NOT wait on
                            emergency services response. There are 4 classes of
                            rescue, risk assessed for most suitable
                        </Typography>
                        <ol>
                            <ListItem text="Lowering a remote casualty" />
                            <ListItem text="Raising a remote casualty" />
                            <ListItem text="Self evacuation by descent" />
                            <ListItem text="Rescue another in descent (preferably avoided so that other complications are not introduced)" />
                        </ol>
                    </Li>
                    <ListItem text="The rescuer should not endanger themselves when carrying out a rescue procedure" />
                    <ListItem text="Will consist of a full-body harness (with webbing and padding), lanyard, shock absorber (if fall arrest rather than fall restraint) and suitable anchor/ tie off point." />
                    <ListItem text="The anchor must be capable of supporting the load in the required direction." />
                    <ListItem text="Ensure proper tie off to anchor points, and re-check before commencing, irrespective of how short the task is going to be." />
                    <ListItem text="The harness must be worn fully secured, comfortable but snug and positioned correctly." />
                    <ListItem text="All connection systems must have double action, self closing, self locking snap hooks to reduce the possibility of roll out" />
                    <ListItem text="Use safety helmets (With chin straps) instead of hard hats." />
                </ul>
            )
        },
        ste_wor_saf_lin: {
            name: "Safety Line/ Grab Line",
            icon: ste_wor_saf_lin,
            text: (
                <ul>
                    <ListItem text="Workers working close the edge of water may have a safety line attached to them to allow for their quick retrieval." />
                    <ListItem text="Grab lines can be placed across shores or downstream to allow workers to self-rescue and pull themselves to safety" />
                </ul>
            )
        },
        ste_wor_net_bea_bag: {
            name: "Nets/ Bean Bags",
            icon: ste_wor_net_bea_bag,
            text: (
                <ul>
                    <Li>
                        <Typography variant="title">
                            Nets should only be erected by competent and trained
                            operatives. They must be installed in accordance
                            with the manufacturer’s instructions, including
                            within the specified range of fixing points. The
                            fall height and catching width is given as
                        </Typography>
                        <StyledTable>
                            <tbody>
                                <tr>
                                    <td>Fall Height</td>
                                    <td>{"< 1m"}</td>
                                    <td>{"< 3m"}</td>
                                    <td>{"< 6m"}</td>
                                </tr>
                                <tr>
                                    <td>Catching width</td>
                                    <td>> 2m</td>
                                    <td>> 2.5m</td>
                                    <td>> 3</td>
                                </tr>
                            </tbody>
                        </StyledTable>
                    </Li>
                    <ListItem text="Nets should be fitted to be less than 2m from fall area (at maximum point of sag)." />
                    <ListItem text="Adequate clearance (from staff, plant or stored materials) must be maintained underneath the net." />
                    <ListItem text="Material or rubbish should not be allowed to fall into nets." />
                    <ListItem text="Bean Bags (Air bags) should only be used where it is not possible to use safety nets. They must be of sufficient strength and have enough air pressure to ensure the falling person does not make contact with the ground. They must be installed in accordance with the manufacturer’s instructions. The guidance above for catching width should be followed over the entire length of the hazard. Bean-bags may be interconnected to achieve this using the manufacturer approved secure couplings." />
                </ul>
            )
        },

        ste_wor_sit_spe_met: {
            name: "Site Specific Method Statement",
            icon: ste_wor_sit_spe_met,
            text: (
                <ul>
                    <ListItem text="A Site Specific Method Statement/ Design will require the engineer/designer to visit the site to carry out the risk assessment. They will then decide on the appropriate controls. This will generally be the case for High Risk works or sites." />
                    <Li>
                        <Typography variant="title">
                            Generally, the engineer/designer will prepare the
                            following documents for you which you must be
                            familiar with and follow
                        </Typography>
                        <ol>
                            <ListItem text="Risk Assessment and Control Selection." />
                            <ListItem text="Contact details for information or site issues" />
                            <ListItem text="Details on design information, such as equipment lists, spacings, visibility, and scope of application of the design" />
                            <ListItem text="Location map" />
                            <ListItem text="Site specific layouts" />
                            <ListItem text="Method statements, these may be standard type operation procedures, or step by step instructions for each phase of the works." />
                            <ListItem text="Details of inspections to be undertaken, and records to be completed." />
                            <ListItem text="Site induction procedures/ Safe Systems of Works Plans" />
                        </ol>
                    </Li>
                </ul>
            )
        }
    }
};

export default json;
